module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_sns_06-a2d53c61847ae052f16653eeb0c2230f.jpg";